import React, { useState, useEffect, useRef } from 'react';
import Header from '../../../Global/Header/Header';
import Footer from '../../../Global/Footer/Footer';
import { post, get, createUrl } from '../../../network/AxiosInterceptor';
import { useToast } from './../../../components/ui/use-toast'
import { Toaster } from "./../../../components/ui/toaster";

const AddBlog = () => {

    const imageUrl = useRef(null);
    const blogUrl = useRef(null);
    const blogIdAlias = useRef(null);
    const authorId = useRef(null);
    const authorPic = useRef(null);
    const createdAt = useRef(null);
    const readingTime = useRef(null);
    const heading = useRef(null);
    const subHeading = useRef(null);
    const blogViews = useRef(null);
    const [authorNames, setAuthorNames] = useState([])

    const { toast } = useToast();

    useEffect(() => {
        toast({}).dismiss();
        window.scrollTo(0, 0);
    }, []);

    const submitHandler = () => {
        try {
            if (!imageUrl.current.value || !blogUrl.current.value || !blogIdAlias.current.value || !authorId.current.value || !authorPic.current.value || !createdAt.current.value || !readingTime.current.value || !heading.current.value || !subHeading.current.value || !blogViews.current.value) {
                showToastOnSaveFailed();
                return;
            }

            try {
                post(createUrl('/api/blogs'), {
                    imageUrl: imageUrl.current.value,
                    blogUrl: blogUrl.current.value,
                    blogIdAlias: blogIdAlias.current.value,
                    authorId: authorId.current.value,
                    authorPic: authorPic.current.value,
                    createdAt: new Date(createdAt.current.value),
                    readingTime: readingTime.current.value,
                    heading: heading.current.value,
                    subHeading: subHeading.current.value,
                    blogViews: blogViews.current.value
                })
                    .then(() => {
                        showToastOnSaveSuccess();
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000)

                    })
                    .catch(() => {
                        showToastOnSaveFailed();
                    });
            } catch (e) {
                console.log(e, ' error')
            }
        } catch (e) {
            showToastOnSaveFailed();
        }


    }

    const showToastOnSaveSuccess = () => {
        toast({
            title: "Exploro",
            description: "Blog Added Successfully",
            variant: "default",
        });
    };

    const showToastOnSaveFailed = () => {
        toast({
            title: "Exploro",
            description: "Error in Blog",
            variant: "destructive",
        });
    };

    useEffect(() => {
        get(createUrl(`/api/users/allUsersForBlogs`)).then((response) => {
            setAuthorNames(response.data);
        })
    }, [])

    return (
        <div className='bg-blue-100'>
            <Header />
            <div className='w-full min-h-[90vh] flex flex-col items-center justify-between mt-[4vw] mb-[4vw]'>
                <div className='w-[30vw] min-h-[27vw] rounded-[10px] bg-blue-200 flex flex-col items-center'>
                    <input ref={imageUrl} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog Card Image Link' />
                    <input ref={blogUrl} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog URL' />
                    <input ref={blogIdAlias} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog Id Alias' />
                    {/* <input ref={authorId} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Author Name' /> */}
                    <label className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw] ' for="dropdown">Select an Author For Blogs</label>
                    <select ref={authorId} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] ' id="dropdown" name="options">
                        {
                            authorNames.map(e => {
                                return <option value={e._id}>{e.firstName} {e.lastName}</option>

                            })
                        }
                    </select>
                    <input ref={authorPic} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Author Profile Pic' />
                    <input ref={createdAt} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='date' placeholder='Created At' />
                    <input ref={readingTime} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Reading Time' />
                    <input ref={heading} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog Heading' />
                    <input ref={subHeading} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog Sub Heading' />
                    <input ref={blogViews} className='w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw]' type='text' placeholder='Blog Views' />
                    <input className="w-[80%] h-[3vw] rounded-[100vw] pl-[1.5vw] pr-[1.5vw] mt-[2vw] mb-[2vw] border-2 bg-green-500 cursor-pointer" type='submit' onClick={submitHandler} />
                </div>
            </div>
            <Footer />
            <Toaster />
        </div>
    )
};

export default AddBlog;